import { Box } from "@mui/material";
import React, { useState } from "react";
import VideoPreviewModal from "@components/VideoPreviewModal";
import YoutubeVideoPreviewModal from "@components/MediaBrowser/YoutubeVideoPreviewModal";
import styled from "styled-components";

function Videos({ videos }) {
  const pattern = /^(https?:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;

  const [openYoutubePreviewVideo, setOpenYoutubePreviewVideo] =
    React.useState(false);
  const [selectedYoutubeVideo, setSelectedYoutubeVideo] = React.useState(null);

  const handleOpenYoutubePreviewVideo = (src) => {
    setSelectedYoutubeVideo(src);
    setOpenYoutubePreviewVideo(true);
  };

  const handleClosePreviewYoutubeVideo = () => {
    setOpenYoutubePreviewVideo(false);
  };

  const [openPreviewVideo, setOpenPreviewVideo] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleOpenPreviewVideo = (src) => {
    setSelectedVideo(src);
    setOpenPreviewVideo(true);
  };

  const handleClosePreviewVideo = () => {
    setOpenPreviewVideo(false);
  };

  function getYoutubeThumbnailUrl(videoUrl) {
    // Extract the video ID from the YouTube URL
    const videoIdMatch = videoUrl.match(
      /(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/watch\?.+&v=))([^\s&]+)/
    );
    if (videoIdMatch) {
      const videoId = videoIdMatch[1];
      // Construct the thumbnail URL
      return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    } else {
      return null; // Return null if the video ID couldn't be extracted
    }
  }

  const StyledBox = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 15px; // Adjusted gap for spacing between grid items
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 15px;
    padding: 10px;
    padding-bottom: 15px;
  `;

  const VideoContainer = styled.div`
    position: relative;
    overflow: hidden;
    width: 28%;
    height: 10vh;
    border-radius: 5px;
    cursor: pointer;
  `;

  const StyledImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
  `;

  const StyledVideo = styled.video`
    width: 140px;
    height: 80px;
    object-fit: cover;
    preload: metadata;
  `;

  return (
    <>
      <StyledBox>
        {videos.map((e, index) => (
          <VideoContainer
            onClick={() => {
              pattern.test(e)
                ? handleOpenYoutubePreviewVideo(e)
                : handleOpenPreviewVideo(e);
            }}
          >
            {pattern.test(e) ? (
              <StyledImage src={getYoutubeThumbnailUrl(e)} alt="ytVideo" />
            ) : (
              <StyledVideo>
                <source src={e} type="video/mp4" />
              </StyledVideo>
            )}
          </VideoContainer>
        ))}
      </StyledBox>
      <VideoPreviewModal
        openPreviewVideo={openPreviewVideo}
        handleClosePreviewVideo={handleClosePreviewVideo}
        videoUrl={selectedVideo}
        customModalStyle={{
          width: "95vw",
          height: "50vh",
        }}
      />

      <YoutubeVideoPreviewModal
        openPreviewVideo={openYoutubePreviewVideo}
        handleClosePreviewVideo={handleClosePreviewYoutubeVideo}
        videoUrl={selectedYoutubeVideo}
        customModalStyle={{
          width: "95vw",
          height: "45vh",
        }}
      />
    </>
  );
}

export default Videos;
